import React, { useState } from 'react';
import {
  Paper,
  Collapse,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  IconButton,
  Dialog,
} from '@material-ui/core';
import { IonRow, IonCol } from '@ionic/react';
import { PLStatement } from '../../models/PLStatement';
import './ProfitLossStatement.scss';
import moment, { Moment } from 'moment';
import PLStatementMktLvl from './PLStatementMktLvl';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import crossIcon from '../../assets/images/common/cross.svg';

type PLProps = {
  items: any;
  totalPL: Map<string, number>;
  startDate: Moment;
  endDate: Moment;
};

const ProfitLossStatement: React.FC<PLProps> = (props) => {
  const { items, totalPL, startDate, endDate } = props;
  const [selectedRecord, setSelectedRecord] = useState<PLStatement>();
  const [open, setOpen] = React.useState<any>({});

  return (
    <>
      <div className="tbl-ctn pl-stmt-tbl tbl-ctn web-view">
        <TableContainer component={Paper}>
          <Table className="myb-table">
            <TableHead className="myb-table-header">
              <TableRow>
                <TableCell></TableCell>
                <TableCell className="game-type-col" align="left">
                  Market
                </TableCell>
                <TableCell className="bwon-col" align="left">
                  Start time
                </TableCell>
                <TableCell className="blost-col" align="left">
                  Settled time
                </TableCell>
                <TableCell className="pandl-col" align="left">
                  Comm.{' '}
                </TableCell>

                <TableCell className="pandl-col" align="left">
                  Net Win
                </TableCell>
              </TableRow>
            </TableHead>

            {items && items.length > 0 ? (
              <>
                <>
                  <TableBody className="tbl-body">
                    {items.map((row, key) => (
                      <>
                        <TableRow
                          className="myb-table-row m-link"
                          key={'key_' + Math.random().toString(36).substr(2, 9)}
                          onClick={() => {
                            setSelectedRecord(row);
                          }}
                        >
                          <TableCell>
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() =>
                                setOpen((prevState) => {
                                  return {
                                    ...prevState,
                                    [moment(key, 'DD-MM-YYYY').format(
                                      'DD/MM/YYYY'
                                    ) +
                                    '-' +
                                    row?.eventId +
                                    '-' +
                                    row?.marketId]: prevState[
                                      moment(key, 'DD-MM-YYYY').format(
                                        'DD/MM/YYYY'
                                      ) +
                                        '-' +
                                        row?.eventId +
                                        '-' +
                                        row?.marketId
                                    ]
                                      ? false
                                      : true,
                                  };
                                })
                              }
                            >
                              {open[
                                moment(key, 'DD-MM-YYYY').format('DD/MM/YYYY') +
                                  '-' +
                                  row?.eventId +
                                  '-' +
                                  row?.marketId
                              ] ? (
                                <KeyboardArrowUpIcon />
                              ) : (
                                <KeyboardArrowDownIcon />
                              )}
                            </IconButton>
                          </TableCell>
                          <TableCell
                            className="myb-table-cell market-name-col m-link"
                            align="left"
                          >
                            <span className="txt-bldin-mob">
                              {row.eventName ? row.eventName : row.gameType} -{' '}
                              {row.marketName}
                            </span>
                          </TableCell>
                          <TableCell
                            className="myb-table-cell bwon-col m-link"
                            align="left"
                          >
                            <span className="txt-bldin-mob">
                              {moment(row.eventDate).format(
                                'D/M/YYYY HH:mm:ss A'
                              )}
                            </span>
                          </TableCell>
                          <TableCell
                            className="myb-table-cell blost-col m-link"
                            align="left"
                          >
                            <span className="txt-bldin-mob">
                              {moment(row.payOutDate).format(
                                'D/M/YYYY HH:mm:ss A'
                              )}
                            </span>
                          </TableCell>
                          <TableCell align="left" className="pandl-col m-link">
                            <span className="txt-bldin-mob">
                              {!row.commission ? (
                                <div>{Number(0).toFixed(2)}</div>
                              ) : row.commission > 0 ? (
                                <div className="profit">
                                  {Number(row.commission).toFixed(2)}
                                </div>
                              ) : row.commission < 0 ? (
                                <div className="loss">
                                  {Number(row.commission).toFixed(2)}
                                </div>
                              ) : (
                                <>{Number(row.commission).toFixed(2) || 0}</>
                              )}
                            </span>
                          </TableCell>

                          <TableCell align="left" className="pandl-col m-link">
                            <span className="txt-bldin-mob">
                              {row.profit > 0 ? (
                                <div className="profit">
                                  {Number(Number(row.profit + row.commission).toFixed(
                                    2
                                  )).toLocaleString('en-US')}
                                </div>
                              ) : row.profit < 0 ? (
                                <div className="loss">
                                  {Number(Number(row.profit + row.commission).toFixed(
                                    2
                                  )).toLocaleString('en-US')}
                                </div>
                              ) : (
                                <>
                                  {' '}
                                  {Number(Number(row.profit + row.commission).toFixed(
                                    2
                                  )).toLocaleString('en-US')}
                                </>
                              )}
                            </span>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell
                            style={{ paddingBottom: 0, paddingTop: 0 }}
                            colSpan={5}
                          >
                            <Collapse
                              in={
                                open[
                                  moment(key, 'DD-MM-YYYY').format(
                                    'DD/MM/YYYY'
                                  ) +
                                    '-' +
                                    row?.eventId +
                                    '-' +
                                    row?.marketId
                                ]
                                  ? true
                                  : false
                              }
                              timeout="auto"
                              unmountOnExit
                              className="Collapse-list"
                            >
                              <Dialog
                                open={open}
                                onClose={() => {
                                  setOpen(false);
                                }}
                                aria-labelledby="responsive-dialog-title"
                                fullWidth={true}
                                className="modal"
                              >
                                <div className="carw">
                                  <div className="arrow arrow-right">
                                    Statement
                                  </div>
                                </div>

                                <div className="modal-content">
                                  <PLStatementMktLvl
                                    selectedMarket={row}
                                    startDate={startDate}
                                    endDate={endDate}
                                    showGameLevel={() => {
                                      setSelectedRecord(null);
                                    }}
                                  />
                                </div>
                              </Dialog>
                            </Collapse>{' '}
                          </TableCell>{' '}
                        </TableRow>
                      </>
                    ))}
                  </TableBody>
                </>
              </>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell
                    className="no-data-cell"
                    variant="body"
                    colSpan={8}
                  >
                    No records found.
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </div>
      {items && items.length > 0 ? (
        <div className="report-card">
          <div className="mob-view mob-ctn-pl">
            <div className="pl-mob-div">
              {items.map((row, key) => (
                <>
                  <div className="pl-content">
                    <IonRow>
                      <IonCol sizeXs="8" sizeSm="8" className="market-info">
                        <div
                          className="link"
                          onClick={() => {
                            setSelectedRecord(row);
                          }}
                        >
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() =>
                              setOpen((prevState) => {
                                return {
                                  ...prevState,
                                  [moment(key, 'DD-MM-YYYY').format(
                                    'DD/MM/YYYY'
                                  ) +
                                  '-' +
                                  row?.eventId +
                                  '-' +
                                  row?.marketId]: prevState[
                                    moment(key, 'DD-MM-YYYY').format(
                                      'DD/MM/YYYY'
                                    ) +
                                      '-' +
                                      row?.eventId +
                                      '-' +
                                      row?.marketId
                                  ]
                                    ? false
                                    : true,
                                };
                              })
                            }
                          >
                            {open[
                              moment(key, 'DD-MM-YYYY').format('DD/MM/YYYY') +
                                '-' +
                                row?.eventId +
                                '-' +
                                row?.marketId
                            ] ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>{' '}
                          {row.eventName ? row.eventName : row.gameType} -{' '}
                          {row.marketName}
                        </div>
                        <div className="b-text">
                          <strong>Start time:</strong>{' '}
                          {moment(row.eventDate).format('D/M/YYYY HH:mm:ss A')}{' '}
                        </div>
                        <div className="b-text">
                          <strong>Settled Time: :</strong>{' '}
                          {moment(row.payOutDate).format('D/M/YYYY HH:mm:ss A')}
                        </div>
                      </IonCol>
                      <IonCol
                        sizeXs="4"
                        sizeSm="4"
                        className="market-amount-info"
                      >
                        <div>
                          <div className="b-text">Comm:</div>
                          <div className="b-text">Net Win:</div>
                        </div>
                        <div>
                          <div className="b-text">
                            {' '}
                            <div>
                              {' '}
                              {!row.commission ? (
                                <div>{Number(0).toFixed(2)}</div>
                              ) : row.commission > 0 ? (
                                <div className="profit">
                                  {Number(Number(row.commission).toFixed(2)).toLocaleString('en-US')}
                                </div>
                              ) : row.commission < 0 ? (
                                <div className="loss">
                                  {Number(Number(row.commission).toFixed(2)).toLocaleString('en-US')}
                                </div>
                              ) : (
                                <>{Number(Number(row.commission).toFixed(2)).toLocaleString('en-US') || 0}</>
                              )}
                            </div>
                          </div>
                          <div className="b-text">
                            {row.profit > 0 ? (
                              <div className="profit">
                                {Number(Number(row.profit + row.commission).toFixed(2)).toLocaleString('en-US')}
                              </div>
                            ) : row.profit < 0 ? (
                              <div className="loss">
                                {Number(Number(row.profit + row.commission).toFixed(2)).toLocaleString('en-US')}
                              </div>
                            ) : (
                              <>
                                {' '}
                                {Number(Number(row.profit + row.commission).toFixed(2)).toLocaleString('en-US')}
                              </>
                            )}
                          </div>
                        </div>
                      </IonCol>
                    </IonRow>
                  </div>
                  <Collapse
                    in={
                      open[
                        moment(key, 'DD-MM-YYYY').format('DD/MM/YYYY') +
                          '-' +
                          row?.eventId +
                          '-' +
                          row?.marketId
                      ]
                        ? true
                        : false
                    }
                    timeout="auto"
                    unmountOnExit
                    className="Collapse-list"
                  >
                    <Dialog
                      open={open}
                      onClose={() => {
                        setOpen(false);
                      }}
                      aria-labelledby="responsive-dialog-title"
                      fullWidth={true}
                      className="modal"
                    >
                      <div className="carw">
                        <div className="arrow arrow-right">Statement</div>
                      </div>

                      <div className="modal-content">
                        <div
                          className="go-corner"
                          onClick={() => {
                            setOpen(false);
                          }}
                        >
                          <img src={crossIcon} alt="crossIcon" />
                        </div>
                        <PLStatementMktLvl
                          selectedMarket={row}
                          startDate={startDate}
                          endDate={endDate}
                          showGameLevel={() => {
                            setSelectedRecord(null);
                          }}
                        />
                      </div>
                    </Dialog>
                  </Collapse>{' '}
                </>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ProfitLossStatement;
